export const defaultColors = ["#b01117", "#a72ed0", "#ea27c2", "#FFA41F"]
